(() => {
  if (window.feelitsGiftBoxOptionInitialized) return;
  window.feelitsGiftBoxOptionInitialized = true;

  let pending = false;
  const root = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
  const endpoint = (path) => root + path;
  const controls = () => [...document.querySelectorAll("[data-feelits-gift-box]")];

  function setControls(checked, disabled) {
    document.querySelectorAll(".cart__checkout-button, [form='mini-cart-form'][name='checkout']").forEach((button) => {
      button.disabled = disabled;
    });
    controls().forEach((card) => {
      card.classList.toggle("is-pending", disabled);
      const input = card.querySelector("[data-feelits-gift-box-toggle]");
      if (!input) return;
      input.checked = checked;
      input.disabled = disabled;
      const status = card.querySelector(".feelits-gift-box-option__status");
      if (status) {
        status.hidden = true;
        status.textContent = "";
      }
    });
  }

  async function request(path, options) {
    const response = await fetch(endpoint(path), {
      credentials: "same-origin",
      cache: "no-store",
      ...options
    });
    if (!response.ok) throw new Error("Cart request failed");
    return response.json();
  }

  function giftLines(cart, variantId) {
    return cart.items.filter((item) => Number(item.variant_id) === variantId);
  }

  document.addEventListener("change", async (event) => {
    const input = event.target.closest("[data-feelits-gift-box-toggle]");
    if (!input || pending) return;
    const card = input.closest("[data-feelits-gift-box]");
    const variantId = Number(card?.dataset.variantId);
    if (!variantId) return;
    const requested = input.checked;
    pending = true;
    document.querySelectorAll(".cart__checkout-button, [form='mini-cart-form'][name='checkout']").forEach((button) => {
      button.disabled = true;
    });
    controls().forEach((control) => {
      control.classList.add("is-pending");
      const checkbox = control.querySelector("[data-feelits-gift-box-toggle]");
      if (checkbox) checkbox.disabled = true;
    });

    let current = null;
    try {
      current = await request("cart.js");
      const lines = giftLines(current, variantId);
      if ((requested && lines.length > 0) || (!requested && lines.length === 0)) {
        setControls(requested, false);
        return;
      }
      if (requested && lines.length === 0) {
        await request("cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      } else if (!requested) {
        for (const line of lines) {
          await request("cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          });
        }
      }
      current = await request("cart.js");
      setControls(giftLines(current, variantId).length > 0, false);
      if (document.body.classList.contains("template-cart") || window.themeVariables?.settings?.pageType === "cart") {
        window.location.reload();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: current } }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: current, openMiniCart: false } }));
      }
    } catch (error) {
      if (current) setControls(giftLines(current, variantId).length > 0, false);
      else setControls(!requested, false);
      controls().forEach((control) => {
        const status = control.querySelector(".feelits-gift-box-option__status");
        if (status) {
          status.textContent = control.dataset.errorMessage || "Could not update the gift box.";
          status.hidden = false;
        }
      });
    } finally {
      pending = false;
    }
  });
})();

